import React from "react";
import ScanConfirmationDialogContainer from "flow-core-components-scanconfirmationdialog";
import { useMuiPageProvider } from "flow-core-components-shared/src/provider/MuiPageProvider/MuiPageProvider";

const ScanDialog = () => {
    const { scanConfirmationDialog } = useMuiPageProvider();

    if (scanConfirmationDialog.length === 0) {
        return null;
    }

    return (
        <>
            {scanConfirmationDialog.map((dialog, index) => (
                <ScanConfirmationDialogContainer
                    key={index}
                    dialogData={dialog}
                />
            ))}
        </>
    );
};

export default ScanDialog;
